import { render } from "./Unit.vue?vue&type=template&id=a23e46ae"
import script from "./Unit.vue?vue&type=script&lang=js"
export * from "./Unit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__